import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { cardStyles, getHeaderStyles, headerMainStyles } from './CicSectionCard.styles';

const CicSectionCard = ({
  title,
  chip = null,
  description = '',
  headerContent = null,
  headerAside = null,
  isHighlighted = false,
  dataTestId = null,
  children,
}) => (
  <Box data-testid={dataTestId} sx={cardStyles}>
    <Box sx={getHeaderStyles({ isHighlighted })}>
      <Box sx={headerMainStyles}>
        {!!chip && <LabelCDS size={LabelSize.S} title={chip.title} variant={chip.variant} />}
        <Typography variant="bold14">{title}</Typography>
        {headerContent}
        {!!description && (
          <Typography color="text.secondary" variant="regular12">
            {description}
          </Typography>
        )}
      </Box>
      {headerAside}
    </Box>
    {children}
  </Box>
);

CicSectionCard.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  chip: PropTypes.shape({
    title: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired,
  }),
  dataTestId: PropTypes.string,
  description: PropTypes.string,
  headerAside: PropTypes.node,
  headerContent: PropTypes.node,
  isHighlighted: PropTypes.bool,
};

export default memo(CicSectionCard);
